// Country codes: https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
import countries from '~/static/data/countries.json'

export const allCountries = Object.entries(countries)
	.map(([countryCode, countryTitle]) => ({ id: countryCode, title: countryTitle }))

const getGoogleAutocompleteOptions = function (country) {
	return {
		types: ['(regions)'],
		componentRestrictions: { country: country || Object.keys(countries) }
	}
}

const preventEnter = (event) => {
	if (event.keyCode === 13) {
		event.preventDefault()
		event.stopPropagation()
	}
}

const googleLocations = {
	line1: ['location'],
	postal_code: ['postal_code'],
	country: ['country'],
	state: ['administrative_area_level_1', 'administrative_area_level_2', 'administrative_area_level_3'],
	city: ['locality', 'postal_town', 'administrative_area_level_2', 'administrative_area_level_3']
}

export class GoogleApi {
	constructor (inputEl, callback, country) {
		const GoogleAutocomplete = window.google && window.google.maps && window.google.maps.places && window.google.maps.places.Autocomplete
		const gMapsEventService = window.google && window.google.maps && window.google.maps.event

		if (!GoogleAutocomplete || !gMapsEventService) {
			// eslint-disable-next-line no-console
			console.warn('Failed to load Google Places Autocomplete')
			return null
		}
		this.callback = callback

		this.autocomplete = new GoogleAutocomplete(inputEl, getGoogleAutocompleteOptions(country))

		if (!this.autocomplete) {
			// eslint-disable-next-line no-console
			console.warn('Failed to load Google Places Autocomplete')
			return null
		}

		this.autocomplete.addListener('place_changed', this.onPlaceChange.bind(this))
		this.autocomplete.setFields(['address_components', 'formatted_address', 'name', 'place_id', 'types', 'geometry'])

		if (GoogleApi.mapsEventService) {
			GoogleApi.mapsEventService.addDomListener(inputEl, 'keydown', preventEnter)
		}
	}

	updateCountryOption (country) {
		const options = getGoogleAutocompleteOptions(country)

		this.autocomplete && this.autocomplete.setOptions(options)
	}

	onPlaceChange (gPlace) {
		const place = gPlace || this.autocomplete.getPlace()

		if (!place) {
			this.callback && this.callback(null)
			return
		}
		this.callback && this.callback(this.extractPlaceData(place))
	}

	extractPlaceData (place = {}) {
		const components = place.address_components || []
		const findAddrType = type => components.find(addr => addr.types.includes(type))

		const placeData = Object.entries(googleLocations)
			.reduce((acc, [key, gTypes]) => {
				if (key === 'line1') {
					acc[key] = place.formatted_address
				} else {
					const gComponent = gTypes.reduce((acc, type) => acc || findAddrType(type), null)
					acc[key] = gComponent && gComponent.long_name
				}

				return acc
			}, {})

		const countryComponent = findAddrType('country')
		placeData.country_code = countryComponent?.short_name

		let geoLocation = null

		if (place.geometry && place.geometry.location) {
			const lat = place.geometry.location.lat()
			const lng = place.geometry.location.lng()

			geoLocation = { uri: `geo:${lat},${lng}` }
		}
		return {
			placeData,
			geoLocation
		}
	}
}
